<template>
  <main class="payment">
    <section class="section">
      <Breadcrumb step="2"></Breadcrumb>
    </section>

    <section class="wrapper section">
      <router-view></router-view>
    </section>
  </main>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue';

export default {
  name: 'selectPayment',
  components: {
    Breadcrumb
  },
  mounted() {
    if (process.env.VUE_APP_ENV === 'production') {
      window.fbq('track', 'PageView');
    }

    if (!sessionStorage.getItem('preRegistered')) {
      this.$router.push({
        name: 'register'
      });
    }
  }
};
</script>
